import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";

const DeleteAccount: React.FC<{
  open: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
}> = ({ open, onCancel = () => {}, onConfirm = () => {} }) => {
  const { t } = useTranslation();
  const [confirmationText, setConfirmationText] = useState("");

  return (
    <Dialog open={open}>
      <DialogTitle>{t("Delete Account")}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: "1rem" }}>
          {t("Are you sure you want to delete your account?")} {t("This action")} <b>{t("cannot be undone")}</b>, {t("and once completed")}, {t("you")}{" "}
          <b>{t("won’t be able to log in to any Relux products or services")}.</b>
          <br />
          <br />
          {t("If you wish to proceed, please confirm your decision.")}
        </DialogContentText>
        <TextField fullWidth label={t("Type YES to confirm")} onChange={e => setConfirmationText(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button disabled={confirmationText !== "YES"} onClick={onConfirm}>
          {t("Delete")}
        </Button>
        <Button onClick={onCancel} variant="contained" autoFocus>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccount;
